import { LoadingEventType } from "../enums/loadingEventType";

class LoadingEvent {

    public id: string;
    public type: LoadingEventType;

    constructor(id: string, type: LoadingEventType) {
        this.id = id;
        this.type = type;
    }
}

export { LoadingEvent }